import { Check } from "lucide-react";
import { whatsappLink } from "@/config/site";

const REASONS = [
  "Ampla formação especializada em sete áreas da Odontologia",
  "Experiência consolidada em Odontologia Clínica e Pericial",
  "Atendimento ético, técnico e personalizado",
  "Produção de laudos rigorosamente fundamentados",
  "Atuação em processos judiciais e extrajudiciais",
  "Atualização científica constante",
  "Compromisso integral com a qualidade técnica e jurídica",
];

export const WhyChoose = () => {
  return (
    <section
      id="diferenciais"
      data-testid="why-choose-section"
      className="relative py-24 md:py-32 bg-[#080808] overflow-hidden"
    >
      <div className="absolute inset-0 gold-glow pointer-events-none opacity-50" />

      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <div className="relative h-full min-h-[480px] lg:min-h-[640px] overflow-hidden border border-[#D4AF37]/20">
              <img
                src="https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/vqtfty4k_WhatsApp%20Image%202026-06-03%20at%2019.18.21.jpeg"
                alt="Dr. Sandrey Miranda Nobre em seu consultório"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent pointer-events-none" />
              {/* Bottom caption */}
              <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
                <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] mb-2">
                  Consultório · Atendimento
                </div>
                <div className="font-serif-display text-xl lg:text-2xl text-white leading-tight">
                  Dr. Sandrey Miranda Nobre
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7 flex flex-col">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
                Diferenciais
              </span>
            </div>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
              Por que escolher o{" "}
              <span className="italic text-[#D4AF37]">
                Dr. Sandrey Nobre
              </span>
              ?
            </h2>
            <p className="mt-6 text-white/65 leading-relaxed max-w-xl">
              Uma combinação rara de profundidade clínica e maturidade
              pericial — a serviço da Justiça e da saúde dos pacientes.
            </p>

            <ul className="mt-10 space-y-px bg-[#D4AF37]/10">
              {REASONS.map((reason, i) => (
                <li
                  key={i}
                  data-testid={`reason-item-${i}`}
                  className="flex items-center gap-5 bg-[#0a0a0a] hover:bg-[#111111] transition-colors duration-300 p-5 group"
                >
                  <div className="w-9 h-9 border border-[#D4AF37]/40 flex items-center justify-center shrink-0 group-hover:bg-[#D4AF37] transition-colors">
                    <Check
                      size={15}
                      strokeWidth={2}
                      className="text-[#D4AF37] group-hover:text-[#050505] transition-colors"
                    />
                  </div>
                  <div className="flex-1">
                    <span className="font-serif-display text-xs text-[#D4AF37]/70 mr-3">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-sm sm:text-base text-white/90">
                      {reason}
                    </span>
                  </div>
                </li>
              ))}
            </ul>

            <a
              href={whatsappLink(
                "Olá Dr. Sandrey, gostaria de conversar sobre uma demanda.",
              )}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="why-cta-whatsapp"
              className="mt-10 inline-flex items-center gap-3 bg-[#D4AF37] text-[#050505] font-medium px-8 py-4 hover:bg-[#F0C950] transition-colors duration-300 self-start"
            >
              Falar com o perito
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
